import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="htmlvideoelement" id="htmlvideoelement"></a>
    <h1 {...{
      "id": "windowhtmlvideoelement"
    }}>{`window.HTMLVideoElement`}</h1>
    <p><strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`preload`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Determines how much the media data be loaded when the plugin loads.      This can be one of the followings. Default is "metadata".      `}<ul>{`          `}<li>{`'none': Video should not be loaded`}</li>{`          `}<li>{`'metadata': Only video metadata is fetched`}</li>{`          `}<li>{`'auto': The whole video file can be downloaded`}</li>{`          `}<li>{`''(empty string): Synonym of the 'auto' value`}</li>{`      `}</ul>{`      example: `}<br></br><inlineCode parentName="td">{`<video src="https://images-tv.adobe.com/mpcv3/b6a5d5f7-5a6c-4bd6-9ee9-ddb6c9c779b3_1564010305.854x480at800_h264.mp4" preload="metadata"></video>`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`autoplay`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Video automatically begins to play back as soon as loading the data.      example: `}<br></br><inlineCode parentName="td">{`<video src="https://images-tv.adobe.com/mpcv3/b6a5d5f7-5a6c-4bd6-9ee9-ddb6c9c779b3_1564010305.854x480at800_h264.mp4" autoplay></video>`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="htmlvideoelement-src" id="htmlvideoelement-src"></a>
    <h2 {...{
      "id": "src--string"
    }}>{`src : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p>{`URL of a media resource.`}</p>
    <a name="htmlvideoelement-currenttime" id="htmlvideoelement-currenttime"></a>
    <h2 {...{
      "id": "currenttime--number"
    }}>{`currentTime : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p>{`Current playback time in seconds.
The seeked event is fired since v7.3.0`}</p>
    <p><strong parentName="p">{`Emits`}</strong>{`: `}<inlineCode parentName="p">{`event:seeked`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`<video id="sampleVideo"  src="https://images-tv.adobe.com/mpcv3/b6a5d5f7-5a6c-4bd6-9ee9-ddb6c9c779b3_1564010305.854x480at800_h264.mp4" preload="metadata">
</video>
<script>
let vid = document.getElementById("sampleVideo");
vid.play();
vid.currentTime = 10;
vid.addEventListener("seeked", (ev) => {
    console.log("Event - seeked");
});
</script>
`}</code></pre>
    <a name="htmlvideoelement-duration" id="htmlvideoelement-duration"></a>
    <h2 {...{
      "id": "duration--number"
    }}>{`duration : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p>{`Length of the media in seconds.`}</p>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`<video id="sampleVideo"  src="https://images-tv.adobe.com/mpcv3/b6a5d5f7-5a6c-4bd6-9ee9-ddb6c9c779b3_1564010305.854x480at800_h264.mp4" preload="metadata">
</video>
<script>
let vid = document.getElementById("sampleVideo");
vid.addEventListener("loadeddata", (ev) => {
    vid.currentTime = vid.duration; //seek to the end of the video
});
</script>
`}</code></pre>
    <a name="htmlvideoelement-muted" id="htmlvideoelement-muted"></a>
    <h2 {...{
      "id": "muted--boolean"
    }}>{`muted : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p>{`Whether the media element is muted.`}</p>
    <a name="htmlvideoelement-volume" id="htmlvideoelement-volume"></a>
    <h2 {...{
      "id": "volume--number"
    }}>{`volume : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p>{`The volume at which the media will be played.
Values must fall between 0 and 1, where 0 is effectively muted and 1 is the loudest possible value.`}</p>
    <a name="htmlvideoelement-volume" id="htmlvideoelement-volume"></a>
    <h2 {...{
      "id": "volume"
    }}>{`volume`}</h2>
    <p>{`Set the volume.
Values must fall between 0 and 1, where 0 is effectively muted and 1 is the loudest possible value.`}</p>
    <p><strong parentName="p">{`Emits`}</strong>{`: `}<inlineCode parentName="p">{`event:volumechange`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`newValue`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`new volume`}</td>
        </tr>
      </tbody>
    </table>
    <a name="htmlvideoelement-played" id="htmlvideoelement-played"></a>
    <h2 {...{
      "id": "played--timeranges"
    }}>{`played : `}<inlineCode parentName="h2">{`TimeRanges`}</inlineCode></h2>
    <p>{`Range of the media source.`}</p>
    <p><strong parentName="p">{`See:`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/TimeRanges"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/TimeRanges`}</a>{`  `}</p>
    <a name="htmlvideoelement-paused" id="htmlvideoelement-paused"></a>
    <h2 {...{
      "id": "paused--boolean"
    }}>{`paused : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p>{`Whether the media element is paused.`}</p>
    <a name="htmlvideoelement-ended" id="htmlvideoelement-ended"></a>
    <h2 {...{
      "id": "ended--boolean"
    }}>{`ended : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p>{`Whether the media element has ended playback.`}</p>
    <a name="htmlvideoelement-error" id="htmlvideoelement-error"></a>
    <h2 {...{
      "id": "error--mediaerror"
    }}>{`error : `}<inlineCode parentName="h2">{`MediaError`}</inlineCode></h2>
    <p>{`MediaError for the most recent error, or null if there has not been an error.`}</p>
    <p><strong parentName="p">{`See:`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/MediaError"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/MediaError`}</a>{`  `}</p>
    <a name="htmlvideoelement-loop" id="htmlvideoelement-loop"></a>
    <h2 {...{
      "id": "loop--boolean"
    }}>{`loop : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p>{`Whether the media element should start over when it reaches the end.`}</p>
    <a name="htmlvideoelement-audiotracks" id="htmlvideoelement-audiotracks"></a>
    <h2 {...{
      "id": "audiotracks--audiotracklist"
    }}>{`audioTracks : `}<inlineCode parentName="h2">{`AudioTrackList`}</inlineCode></h2>
    <p>{`AudioTrackList object listing all of the AudioTrack objects representing the media's audio tracks.`}</p>
    <p><strong parentName="p">{`See:`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/AudioTrackList"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/AudioTrackList`}</a>{`  `}</p>
    <a name="htmlvideoelement-videotracks" id="htmlvideoelement-videotracks"></a>
    <h2 {...{
      "id": "videotracks--videotracklist"
    }}>{`videoTracks : `}<inlineCode parentName="h2">{`VideoTrackList`}</inlineCode></h2>
    <p>{`VideoTrackList object listing all of the VideoTrack objects representing the media's video tracks.`}</p>
    <p><strong parentName="p">{`See:`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/VideoTrackList"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/VideoTrackList`}</a>{`  `}</p>
    <a name="htmlvideoelement-texttracks" id="htmlvideoelement-texttracks"></a>
    <h2 {...{
      "id": "texttracks--texttracklist"
    }}>{`textTracks : `}<inlineCode parentName="h2">{`TextTrackList`}</inlineCode></h2>
    <p>{`TextTrackList object listing all of the TextTrack objects representing the media's text tracks`}</p>
    <p><strong parentName="p">{`See:`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/TextTrackList"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/TextTrackList`}</a>{`  `}</p>
    <a name="htmlvideoelement-videowidth" id="htmlvideoelement-videowidth"></a>
    <h2 {...{
      "id": "videowidth--number"
    }}>{`videoWidth : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Width of the video in pixel.`}</p>
    <p><strong parentName="p">{`Since`}</strong>{`: v7.4.0  `}</p>
    <a name="htmlvideoelement-videoheight" id="htmlvideoelement-videoheight"></a>
    <h2 {...{
      "id": "videoheight--number"
    }}>{`videoHeight : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Height of the video in pixel.`}</p>
    <p><strong parentName="p">{`Since`}</strong>{`: v7.4.0  `}</p>
    <a name="htmlvideoelement-playbackrate" id="htmlvideoelement-playbackrate"></a>
    <h2 {...{
      "id": "playbackrate--number"
    }}>{`playbackRate : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p>{`The rate at which the media is being played back.
1.0 is normal speed, values lower than 1.0 make the media play slower than normal,
higher values make it play faster. Default is 1.0.`}</p>
    <a name="htmlvideoelement-playbackrate" id="htmlvideoelement-playbackrate"></a>
    <h2 {...{
      "id": "playbackrate"
    }}>{`playbackRate`}</h2>
    <p>{`Set the rate at which the media is being played back.`}</p>
    <p><strong parentName="p">{`Emits`}</strong>{`: `}<inlineCode parentName="p">{`event:ratechange`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`newValue`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`playback rate`}</td>
        </tr>
      </tbody>
    </table>
    <a name="htmlelement-dataset" id="htmlelement-dataset"></a>
    <h2 {...{
      "id": "dataset"
    }}>{`dataset`}</h2>
    <p>{`Access to all the custom data attributes (data-*) set.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/dataset"
      }}>{`HTMLElement - dataset`}</a>{`  `}</p>
    <a name="htmlelement-innertext" id="htmlelement-innertext"></a>
    <h2 {...{
      "id": "innertext--string"
    }}>{`innerText : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <a name="htmlelement-lang" id="htmlelement-lang"></a>
    <h2 {...{
      "id": "lang--string"
    }}>{`lang : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p>{`Base language of an element's attribute values and text content.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/lang"
      }}>{`HTMLElement - lang`}</a>{`  `}</p>
    <a name="htmlelement-dir" id="htmlelement-dir"></a>
    <h2 {...{
      "id": "dir--string"
    }}>{`dir : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p>{`The text writing directionality of the content of the current element limited to only known values.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/dir"
      }}>{`HTMLElement - dir`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v7.1  `}</p>
    <a name="htmlelement-hidden" id="htmlelement-hidden"></a>
    <h2 {...{
      "id": "hidden--boolean--string"
    }}>{`hidden : `}<inlineCode parentName="h2">{`boolean`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p>{`Indicates the browser should not render the contents of the element. Note: "until-found" is not supported.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/hidden"
      }}>{`HTMLElement - hidden`}</a>{`, `}<a parentName="p" {...{
        "href": "https://html.spec.whatwg.org/multipage/interaction.html#the-hidden-attribute"
      }}>{`Spec - `}<inlineCode parentName="a">{`hidden`}</inlineCode>{` attribute`}</a>{`  `}</p>
    <a name="element-nodename" id="element-nodename"></a>
    <h2 {...{
      "id": "nodename--string"
    }}>{`nodeName : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="element-localname" id="element-localname"></a>
    <h2 {...{
      "id": "localname--string"
    }}>{`localName : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
A string representing the local part of the qualified name of the element`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Element/localName"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/Element/localName`}</a>{`  `}</p>
    <a name="element-tagname" id="element-tagname"></a>
    <h2 {...{
      "id": "tagname--string"
    }}>{`tagName : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
A string indicating the element's tag name`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Element/tagName"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/Element/tagName`}</a>{`  `}</p>
    <a name="element-nodetype" id="element-nodetype"></a>
    <h2 {...{
      "id": "nodetype--number"
    }}>{`nodeType : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="element-namespaceuri" id="element-namespaceuri"></a>
    <h2 {...{
      "id": "namespaceuri--string"
    }}>{`namespaceURI : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Returns the namespace URI of the element, or null if the element is not in a namespace.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Element/namespaceURI"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/Element/namespaceURI`}</a>{`  `}</p>
    <a name="element-id" id="element-id"></a>
    <h2 {...{
      "id": "id--string"
    }}>{`id : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p>{`Returns the property of the `}<inlineCode parentName="p">{`Element`}</inlineCode>{` interface represents the element's identifier, reflecting the id global attribute.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Element/id"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/Element/id`}</a>{`  `}</p>
    <a name="element-tabindex" id="element-tabindex"></a>
    <h2 {...{
      "id": "tabindex--number"
    }}>{`tabIndex : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <a name="element-classname" id="element-classname"></a>
    <h2 {...{
      "id": "classname--string"
    }}>{`className : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <a name="element-attributes" id="element-attributes"></a>
    <h2 {...{
      "id": "attributes--namednodemap"
    }}>{`attributes : `}<inlineCode parentName="h2">{`NamedNodeMap`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="element-style" id="element-style"></a>
    <h2 {...{
      "id": "style--style"
    }}>{`style : `}<inlineCode parentName="h2">{`Style`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="element-clientleft" id="element-clientleft"></a>
    <h2 {...{
      "id": "clientleft--number"
    }}>{`clientLeft : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="element-clienttop" id="element-clienttop"></a>
    <h2 {...{
      "id": "clienttop--number"
    }}>{`clientTop : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="element-clientwidth" id="element-clientwidth"></a>
    <h2 {...{
      "id": "clientwidth--number"
    }}>{`clientWidth : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="element-clientheight" id="element-clientheight"></a>
    <h2 {...{
      "id": "clientheight--number"
    }}>{`clientHeight : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="element-offsetparent" id="element-offsetparent"></a>
    <h2 {...{
      "id": "offsetparent--element"
    }}>{`offsetParent : `}<inlineCode parentName="h2">{`Element`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="element-offsetleft" id="element-offsetleft"></a>
    <h2 {...{
      "id": "offsetleft--number"
    }}>{`offsetLeft : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="element-offsettop" id="element-offsettop"></a>
    <h2 {...{
      "id": "offsettop--number"
    }}>{`offsetTop : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="element-offsetwidth" id="element-offsetwidth"></a>
    <h2 {...{
      "id": "offsetwidth--number"
    }}>{`offsetWidth : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="element-offsetheight" id="element-offsetheight"></a>
    <h2 {...{
      "id": "offsetheight--number"
    }}>{`offsetHeight : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="element-scrollleft" id="element-scrollleft"></a>
    <h2 {...{
      "id": "scrollleft--number"
    }}>{`scrollLeft : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <a name="element-scrolltop" id="element-scrolltop"></a>
    <h2 {...{
      "id": "scrolltop--number"
    }}>{`scrollTop : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <a name="element-scrollwidth" id="element-scrollwidth"></a>
    <h2 {...{
      "id": "scrollwidth--number"
    }}>{`scrollWidth : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="element-scrollheight" id="element-scrollheight"></a>
    <h2 {...{
      "id": "scrollheight--number"
    }}>{`scrollHeight : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="element-autofocus" id="element-autofocus"></a>
    <h2 {...{
      "id": "autofocus--boolean"
    }}>{`autofocus : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p>{`Indicates if the element will focus automatically when it is loaded`}</p>
    <a name="element-uxpcontainer" id="element-uxpcontainer"></a>
    <h2 {...{
      "id": "uxpcontainer--number"
    }}>{`uxpContainer : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="element-shadowroot" id="element-shadowroot"></a>
    <h2 {...{
      "id": "shadowroot--shadowroot"
    }}>{`shadowRoot : `}<inlineCode parentName="h2">{`ShadowRoot`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
`}{`[ This feature is behind a feature flag. You must turn on `}<inlineCode parentName="p">{`enableSWCSupport`}</inlineCode>{` in the featureFlags section of plugin manifest to use the same ]`}</p>
    <p>{`Returns the open shadow root that is hosted by the element, or null if no open shadow root is present.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Element/shadowRoot"
      }}>{`Element - shadowRoot`}</a>{`  `}</p>
    <a name="element-disabled" id="element-disabled"></a>
    <h2 {...{
      "id": "disabled--boolean"
    }}>{`disabled : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <a name="element-innerhtml" id="element-innerhtml"></a>
    <h2 {...{
      "id": "innerhtml"
    }}>{`innerHTML`}</h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="element-outerhtml" id="element-outerhtml"></a>
    <h2 {...{
      "id": "outerhtml--string"
    }}>{`outerHTML : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <a name="element-slot" id="element-slot"></a>
    <h2 {...{
      "id": "slot--string"
    }}>{`slot : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p>{`[ This feature is behind a feature flag. You must turn on `}<inlineCode parentName="p">{`enableSWCSupport`}</inlineCode>{` in the featureFlags section of plugin manifest to use the same ]`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Element/slot"
      }}>{`Element - slot`}</a>{`  `}</p>
    <a name="element-assignedslot" id="element-assignedslot"></a>
    <h2 {...{
      "id": "assignedslot--htmlslotelement"
    }}>{`assignedSlot : `}<inlineCode parentName="h2">{`HTMLSlotElement`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
`}{`[ This feature is behind a feature flag. You must turn on `}<inlineCode parentName="p">{`enableSWCSupport`}</inlineCode>{` in the featureFlags section of plugin manifest to use the same ]`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Element/assignedSlot"
      }}>{`Element - assignedSlot`}</a>{`  `}</p>
    <a name="node-contenteditable" id="node-contenteditable"></a>
    <h2 {...{
      "id": "contenteditable"
    }}>{`contentEditable`}</h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-isconnected" id="node-isconnected"></a>
    <h2 {...{
      "id": "isconnected--boolean"
    }}>{`isConnected : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-parentnode" id="node-parentnode"></a>
    <h2 {...{
      "id": "parentnode--node"
    }}>{`parentNode : `}<inlineCode parentName="h2">{`Node`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-parentelement" id="node-parentelement"></a>
    <h2 {...{
      "id": "parentelement--element"
    }}>{`parentElement : `}<inlineCode parentName="h2">{`Element`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-firstchild" id="node-firstchild"></a>
    <h2 {...{
      "id": "firstchild--node"
    }}>{`firstChild : `}<inlineCode parentName="h2">{`Node`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-lastchild" id="node-lastchild"></a>
    <h2 {...{
      "id": "lastchild--node"
    }}>{`lastChild : `}<inlineCode parentName="h2">{`Node`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-previoussibling" id="node-previoussibling"></a>
    <h2 {...{
      "id": "previoussibling--node"
    }}>{`previousSibling : `}<inlineCode parentName="h2">{`Node`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-nextsibling" id="node-nextsibling"></a>
    <h2 {...{
      "id": "nextsibling--node"
    }}>{`nextSibling : `}<inlineCode parentName="h2">{`Node`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-firstelementchild" id="node-firstelementchild"></a>
    <h2 {...{
      "id": "firstelementchild--node"
    }}>{`firstElementChild : `}<inlineCode parentName="h2">{`Node`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-lastelementchild" id="node-lastelementchild"></a>
    <h2 {...{
      "id": "lastelementchild--node"
    }}>{`lastElementChild : `}<inlineCode parentName="h2">{`Node`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-previouselementsibling" id="node-previouselementsibling"></a>
    <h2 {...{
      "id": "previouselementsibling--node"
    }}>{`previousElementSibling : `}<inlineCode parentName="h2">{`Node`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-nextelementsibling" id="node-nextelementsibling"></a>
    <h2 {...{
      "id": "nextelementsibling--node"
    }}>{`nextElementSibling : `}<inlineCode parentName="h2">{`Node`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-textcontent" id="node-textcontent"></a>
    <h2 {...{
      "id": "textcontent--string"
    }}>{`textContent : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <a name="node-childnodes" id="node-childnodes"></a>
    <h2 {...{
      "id": "childnodes--nodelist"
    }}>{`childNodes : `}<inlineCode parentName="h2">{`NodeList`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-children" id="node-children"></a>
    <h2 {...{
      "id": "children--htmlcollection"
    }}>{`children : `}<inlineCode parentName="h2">{`HTMLCollection`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-ownerdocument" id="node-ownerdocument"></a>
    <h2 {...{
      "id": "ownerdocument"
    }}>{`ownerDocument`}</h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="htmlvideoelement-canplaytype" id="htmlvideoelement-canplaytype"></a>
    <h2 {...{
      "id": "canplaytypemimetype"
    }}>{`canPlayType(mimeType)`}</h2>
    <p>{`How likely it is that UXP's media player will be able to play media of a given MIME type.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - How likely it is that the media can be played. One of the followings.`}</p>
    <pre><code parentName="pre" {...{}}>{` <ul>
     <li>''(empty string): Media cannot be played on the current device.</li>
     <li>'probably': Media is probably playable on the current device.</li>
     <li>'maybe': There is not enough information to determine whether the media can play.</li>
 </ul>  
`}</code></pre>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`mimeType`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`MIME type of the media.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="htmlvideoelement-load" id="htmlvideoelement-load"></a>
    <h2 {...{
      "id": "load"
    }}>{`load()`}</h2>
    <p>{`Resets the media to its initial state and begins the process of selecting a media source
and loading the media in preparation for playback.
The amount of media data that is prefetched is determined by the value of 'preload' attribute.`}</p>
    <p><strong parentName="p">{`Emits`}</strong>{`: `}<inlineCode parentName="p">{`event:loadedmetadata`}</inlineCode>{`, `}<inlineCode parentName="p">{`event:loadeddata`}</inlineCode>{`, `}<inlineCode parentName="p">{`event:uxpvideoload - Deprecated: Use loadeddata instead`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`<video id="sampleVideo"  src="https://images-tv.adobe.com/mpcv3/b6a5d5f7-5a6c-4bd6-9ee9-ddb6c9c779b3_1564010305.854x480at800_h264.mp4" preload="none">
</video>
<script>
let vid = document.getElementById("sampleVideo");
vid.load();
vid.addEventListener("loadedmetadata", (ev) => {
    console.log("Event - loadedmetadata");
});
vid.addEventListener("loadeddata", (ev) => {
    console.log("Event - loadeddata");
});
</script>
`}</code></pre>
    <a name="htmlvideoelement-play" id="htmlvideoelement-play"></a>
    <h2 {...{
      "id": "play"
    }}>{`play()`}</h2>
    <p>{`Attempts to begin playback of the media.`}</p>
    <br></br>Note that it returns a resolved Promise regardless of the actual result.
It notifies an error over the error event.
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<void>`}</inlineCode>{` Resolved when playback has been started, or rejected if playback cannot be started.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Emits`}</strong>{`: `}<inlineCode parentName="p">{`event:play`}</inlineCode>{`, `}<inlineCode parentName="p">{`event:uxpvideoplay - Deprecated: Use play instead`}</inlineCode>{`, `}<inlineCode parentName="p">{`event:ended`}</inlineCode>{`, `}<inlineCode parentName="p">{`event:uxpvideocomplete - Deprecated: Use ended instead`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`<video id="sampleVideo"  src="https://images-tv.adobe.com/mpcv3/b6a5d5f7-5a6c-4bd6-9ee9-ddb6c9c779b3_1564010305.854x480at800_h264.mp4" preload="metadata">
</video>
<script>
let vid = document.getElementById("sampleVideo");
vid.play();
vid.addEventListener("play", (ev) => {
    console.log("Event - play");
});
</script>
`}</code></pre>
    <a name="htmlvideoelement-pause" id="htmlvideoelement-pause"></a>
    <h2 {...{
      "id": "pause"
    }}>{`pause()`}</h2>
    <p>{`Pause the playback of the media. If the media is already in a paused state, no effect.`}</p>
    <p><strong parentName="p">{`Emits`}</strong>{`: `}<inlineCode parentName="p">{`event:pause`}</inlineCode>{`, `}<inlineCode parentName="p">{`event:uxpvideopause - Deprecated: Use pause instead`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`<video id="sampleVideo"  src="https://images-tv.adobe.com/mpcv3/b6a5d5f7-5a6c-4bd6-9ee9-ddb6c9c779b3_1564010305.854x480at800_h264.mp4" preload="metadata">
</video>
<script>
let vid = document.getElementById("sampleVideo");
vid.play();
vid.pause();
vid.addEventListener("pause", (ev) => {
    console.log("Event - pause");
});
</script>
`}</code></pre>
    <a name="htmlvideoelement-fastseek" id="htmlvideoelement-fastseek"></a>
    <h2 {...{
      "id": "fastseek"
    }}>{`fastSeek()`}</h2>
    <p>{`Seeks the media to the new time quickly with precision tradeoff.`}</p>
    <p><strong parentName="p">{`Emits`}</strong>{`: `}<inlineCode parentName="p">{`event:seeked`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/fastSeek"
      }}>{`fastSeek`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v7.4.0`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`<video id="sampleVideo"  src="https://images-tv.adobe.com/mpcv3/b6a5d5f7-5a6c-4bd6-9ee9-ddb6c9c779b3_1564010305.854x480at800_h264.mp4" preload="metadata">
</video>
<script>
let vid = document.getElementById("sampleVideo");
vid.play();
vid.fastSeek(10);
vid.addEventListener("seeked", (ev) => {
    console.log("Event - seeked");
});
</script>
`}</code></pre>
    <a name="htmlvideoelement-stop" id="htmlvideoelement-stop"></a>
    <h2 {...{
      "id": "stop"
    }}>{`stop()`}</h2>
    <p>{`Pause the playback of the media and set the current playback time to the beginning.`}</p>
    <p><strong parentName="p">{`Emits`}</strong>{`: `}<inlineCode parentName="p">{`event:uxpvideostop`}</inlineCode>{`, `}<inlineCode parentName="p">{`event:seeked`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`<video id="sampleVideo"  src="https://images-tv.adobe.com/mpcv3/b6a5d5f7-5a6c-4bd6-9ee9-ddb6c9c779b3_1564010305.854x480at800_h264.mp4" preload="metadata">
</video>
<script>
let vid = document.getElementById("sampleVideo");
vid.play();
vid.stop();
vid.addEventListener("uxpvideostop", (ev) => {
    console.log("Event - uxpvideostop");
});
vid.addEventListener("seeked", (ev) => {
    console.log("Event - seeked");
});
</script>
`}</code></pre>
    <a name="element-append" id="element-append"></a>
    <h2 {...{
      "id": "appendnodes"
    }}>{`append(...nodes)`}</h2>
    <p>{`Inserts a set of Node objects or string objects after the last child of the Element.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Element/append"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/Element/append`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v8.0  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`...nodes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array<Node>`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="element-prepend" id="element-prepend"></a>
    <h2 {...{
      "id": "prependnodes"
    }}>{`prepend(...nodes)`}</h2>
    <p>{`Inserts a set of Node objects or string objects before the first child of the Element.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Element/prepend"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/Element/prepend`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v8.0  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`...nodes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array<Node>`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="element-replacechildren" id="element-replacechildren"></a>
    <h2 {...{
      "id": "replacechildrennodes"
    }}>{`replaceChildren(...nodes)`}</h2>
    <p>{`Replaces the existing children of a Node with a specified new set of children. These can be string or Node objects.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Element/replaceChildren"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/Element/replaceChildren`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v8.0  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`...nodes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array<Node>`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="element-scrollto" id="element-scrollto"></a>
    <h2 {...{
      "id": "scrolltoxoroptions-y"
    }}>{`scrollTo(xOrOptions, y)`}</h2>
    <p>{`Scrolls the element to the new x and y positions. If options object is used with behavior: "smooth" then the element is smoothly scrolled.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollTo"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollTo`}</a>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`xOrOptions`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`either the new scrollLeft position or an options object.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`y`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`the optional new scrollTop position.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="element-scrollintoview" id="element-scrollintoview"></a>
    <h2 {...{
      "id": "scrollintoviewaligntotop"
    }}>{`scrollIntoView(alignToTop)`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`alignToTop`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="element-scrollintoviewifneeded" id="element-scrollintoviewifneeded"></a>
    <h2 {...{
      "id": "scrollintoviewifneeded"
    }}>{`scrollIntoViewIfNeeded()`}</h2>
    <a name="element-attachshadow" id="element-attachshadow"></a>
    <h2 {...{
      "id": "attachshadowinit"
    }}>{`attachShadow(init)`}</h2>
    <p>{`[ This feature is behind a feature flag. You must turn on `}<inlineCode parentName="p">{`enableSWCSupport`}</inlineCode>{` in the featureFlags section of plugin manifest to use the same ]`}</p>
    <p>{`Attaches a shadow DOM tree to the specified element and returns a reference to its ShadowRoot.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`ShadowRoot`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Element/attachShadow"
      }}>{`Element - attachShadow`}</a>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`init`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An object which contains the fields : mode(open/closed) , delegatesFocus ,slotAssignment`}</td>
        </tr>
      </tbody>
    </table>
    <a name="element-focus" id="element-focus"></a>
    <h2 {...{
      "id": "focus"
    }}>{`focus()`}</h2>
    <a name="element-blur" id="element-blur"></a>
    <h2 {...{
      "id": "blur"
    }}>{`blur()`}</h2>
    <a name="element-getattribute" id="element-getattribute"></a>
    <h2 {...{
      "id": "getattributename"
    }}>{`getAttribute(name)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Element/getAttribute"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/Element/getAttribute`}</a>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Name of the attribute whose value you want to get.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="element-setattribute" id="element-setattribute"></a>
    <h2 {...{
      "id": "setattributename-value"
    }}>{`setAttribute(name, value)`}</h2>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Element/setAttribute"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/Element/setAttribute`}</a>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Name of the attribute whose value is to be set`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`value`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Value to assign to the attribute`}</td>
        </tr>
      </tbody>
    </table>
    <a name="element-removeattribute" id="element-removeattribute"></a>
    <h2 {...{
      "id": "removeattributename"
    }}>{`removeAttribute(name)`}</h2>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Element/removeAttribute"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/Element/removeAttribute`}</a>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="element-hasattribute" id="element-hasattribute"></a>
    <h2 {...{
      "id": "hasattributename"
    }}>{`hasAttribute(name)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`boolean`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Element/hasAttribute"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/Element/hasAttribute`}</a>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="element-hasattributes" id="element-hasattributes"></a>
    <h2 {...{
      "id": "hasattributes"
    }}>{`hasAttributes()`}</h2>
    <p>{`Returns a boolean value indicating whether the current element has any attributes or not.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`boolean`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Element/hasAttributes"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/Element/hasAttributes`}</a>{`  `}</p>
    <a name="element-getattributenames" id="element-getattributenames"></a>
    <h2 {...{
      "id": "getattributenames"
    }}>{`getAttributeNames()`}</h2>
    <p>{`Returns the attribute names of the element as an Array of strings`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Array`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Element/getAttributeNames"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/Element/getAttributeNames`}</a>{`  `}</p>
    <a name="element-getattributenode" id="element-getattributenode"></a>
    <h2 {...{
      "id": "getattributenodename"
    }}>{`getAttributeNode(name)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`*`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Element/getAttributeNode"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/Element/getAttributeNode`}</a>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="element-setattributenode" id="element-setattributenode"></a>
    <h2 {...{
      "id": "setattributenodenewattr"
    }}>{`setAttributeNode(newAttr)`}</h2>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Element/setAttributeNode"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/Element/setAttributeNode`}</a>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`newAttr`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="element-removeattributenode" id="element-removeattributenode"></a>
    <h2 {...{
      "id": "removeattributenodeoldattr"
    }}>{`removeAttributeNode(oldAttr)`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`oldAttr`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="element-click" id="element-click"></a>
    <h2 {...{
      "id": "click"
    }}>{`click()`}</h2>
    <a name="element-getelementsbyclassname" id="element-getelementsbyclassname"></a>
    <h2 {...{
      "id": "getelementsbyclassnamename"
    }}>{`getElementsByClassName(name)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`NodeList`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="element-getelementsbytagname" id="element-getelementsbytagname"></a>
    <h2 {...{
      "id": "getelementsbytagnamename"
    }}>{`getElementsByTagName(name)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`NodeList`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="element-queryselector" id="element-queryselector"></a>
    <h2 {...{
      "id": "queryselectorselector"
    }}>{`querySelector(selector)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Element`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`selector`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="element-queryselectorall" id="element-queryselectorall"></a>
    <h2 {...{
      "id": "queryselectorallselector"
    }}>{`querySelectorAll(selector)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`NodeList`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`selector`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="element-setpointercapture" id="element-setpointercapture"></a>
    <h2 {...{
      "id": "setpointercapturepointerid"
    }}>{`setPointerCapture(pointerId)`}</h2>
    <p>{`Sets pointer capture for the element. This implementation does not dispatch the `}<inlineCode parentName="p">{`gotpointercapture`}</inlineCode>{` event on the element.`}</p>
    <p><strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`DOMException`}</inlineCode>{` If the element is not connected to the DOM.`}</li>
    </ul>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Element/setPointerCapture"
      }}>{`Element - setPointerCapture`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v7.1  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`pointerId`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The unique identifier of the pointer to be captured.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// HTML
<style>
    div {
        width: 140px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #fbe;
        position: absolute;
    }
</style>
<div id="slider">SLIDE ME</div>

// JS
function beginSliding(e) {
     slider.setPointerCapture(e.pointerId);
     slider.addEventListener("pointermove", slide);
 }

 function stopSliding(e) {
     slider.releasePointerCapture(e.pointerId);
     slider.removeEventListener("pointermove", slide);
 }

 function slide(e) {
     slider.style.left = e.clientX;
 }

 const slider = document.getElementById("slider");

 slider.addEventListener("pointerdown", beginSliding);
 slider.addEventListener("pointerup", stopSliding);
`}</code></pre>
    <a name="element-releasepointercapture" id="element-releasepointercapture"></a>
    <h2 {...{
      "id": "releasepointercapturepointerid"
    }}>{`releasePointerCapture(pointerId)`}</h2>
    <p>{`Releases pointer capture for the element. This implementation does not dispatch the `}<inlineCode parentName="p">{`lostpointercapture`}</inlineCode>{` event on the element.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Element/releasePointerCapture"
      }}>{`Element - releasePointerCapture`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v7.1  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`pointerId`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The unique identifier of the pointer to be released.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="element-haspointercapture" id="element-haspointercapture"></a>
    <h2 {...{
      "id": "haspointercapturepointerid"
    }}>{`hasPointerCapture(pointerId)`}</h2>
    <p>{`Checks if the element has pointer capture for the specified pointer.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`boolean`}</inlineCode>{` - True if the element has pointer capture for the specified pointer, false otherwise.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Element/hasPointerCapture"
      }}>{`Element - hasPointerCapture`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v7.1  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`pointerId`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The unique identifier of the pointer to check.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="element-getboundingclientrect" id="element-getboundingclientrect"></a>
    <h2 {...{
      "id": "getboundingclientrect"
    }}>{`getBoundingClientRect()`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`*`}</inlineCode>{`  `}</p>
    <a name="element-closest" id="element-closest"></a>
    <h2 {...{
      "id": "closestselectorstring"
    }}>{`closest(selectorString)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Element`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Element/closest"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/Element/closest`}</a>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`selectorString`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="element-matches" id="element-matches"></a>
    <h2 {...{
      "id": "matchesselectorstring"
    }}>{`matches(selectorString)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`boolean`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Element/matches"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/Element/matches`}</a>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`selectorString`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="element-insertadjacenthtml" id="element-insertadjacenthtml"></a>
    <h2 {...{
      "id": "insertadjacenthtmlposition-value"
    }}>{`insertAdjacentHTML(position, value)`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`position`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`value`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="element-insertadjacentelement" id="element-insertadjacentelement"></a>
    <h2 {...{
      "id": "insertadjacentelementposition-node"
    }}>{`insertAdjacentElement(position, node)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Node`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`position`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`node`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="element-insertadjacenttext" id="element-insertadjacenttext"></a>
    <h2 {...{
      "id": "insertadjacenttextposition-text"
    }}>{`insertAdjacentText(position, text)`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`position`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="node-haschildnodes" id="node-haschildnodes"></a>
    <h2 {...{
      "id": "haschildnodes"
    }}>{`hasChildNodes()`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`boolean`}</inlineCode>{`  `}</p>
    <a name="node-clonenode" id="node-clonenode"></a>
    <h2 {...{
      "id": "clonenodedeep"
    }}>{`cloneNode(deep)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Node`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`deep`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="node-appendchild" id="node-appendchild"></a>
    <h2 {...{
      "id": "appendchildchild"
    }}>{`appendChild(child)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Node`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`child`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Node`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="node-insertbefore" id="node-insertbefore"></a>
    <h2 {...{
      "id": "insertbeforechild-before"
    }}>{`insertBefore(child, before)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Node`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`child`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Node`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`before`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Node`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="node-replacechild" id="node-replacechild"></a>
    <h2 {...{
      "id": "replacechildnewchild-oldchild"
    }}>{`replaceChild(newChild, oldChild)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Node`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`newChild`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Node`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`oldChild`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Node`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="node-removechild" id="node-removechild"></a>
    <h2 {...{
      "id": "removechildchild"
    }}>{`removeChild(child)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Node`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`child`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Node`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="node-remove" id="node-remove"></a>
    <h2 {...{
      "id": "remove"
    }}>{`remove()`}</h2>
    <a name="node-before" id="node-before"></a>
    <h2 {...{
      "id": "beforenodes"
    }}>{`before(...nodes)`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`...nodes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array<Node>`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="node-after" id="node-after"></a>
    <h2 {...{
      "id": "afternodes"
    }}>{`after(...nodes)`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`...nodes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array<Node>`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="node-replacewith" id="node-replacewith"></a>
    <h2 {...{
      "id": "replacewithnodes"
    }}>{`replaceWith(...nodes)`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`...nodes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array<Node>`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="node-contains" id="node-contains"></a>
    <h2 {...{
      "id": "containsnode"
    }}>{`contains(node)`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`node`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Node`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="node-getrootnode" id="node-getrootnode"></a>
    <h2 {...{
      "id": "getrootnodeoptions"
    }}>{`getRootNode(options)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Node`}</inlineCode>{` - root node  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="eventtarget-addeventlistener" id="eventtarget-addeventlistener"></a>
    <h2 {...{
      "id": "addeventlistenereventname-callback-options"
    }}>{`addEventListener(eventName, callback, options)`}</h2>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener"
      }}>{`EventTarget - addEventListener`}</a>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`eventName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`callback`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Boolean value denoting capture value or options object. Currently supports only capture in options object ({ capture: bool_value }).`}</td>
        </tr>
      </tbody>
    </table>
    <a name="eventtarget-removeeventlistener" id="eventtarget-removeeventlistener"></a>
    <h2 {...{
      "id": "removeeventlistenereventname-callback-options"
    }}>{`removeEventListener(eventName, callback, options)`}</h2>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener"
      }}>{`EventTarget - removeEventListener`}</a>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`eventName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`callback`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Boolean value denoting capture value or options object. Currently supports only capture in options object ({ capture: bool_value }).`}</td>
        </tr>
      </tbody>
    </table>
    <a name="eventtarget-dispatchevent" id="eventtarget-dispatchevent"></a>
    <h2 {...{
      "id": "dispatcheventevent"
    }}>{`dispatchEvent(event)`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`event`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      